import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../atoms';

interface PaginationProps {
  page: number;
  totalPages: number;
  start: number;
  end: number;
  total: number;
  onPageChange: (page: number) => void;
}

/** Prev/next paging for a table footer; hides itself when everything fits on one page. */
export function Pagination({ page, totalPages, start, end, total, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between gap-3 border-t border-line px-5 py-3">
      <span className="text-[13px] text-fg-muted">
        {start}–{end} of {total}
      </span>
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          aria-label="Previous page"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          icon={<ChevronLeft size={14} aria-hidden />}
        />
        <span className="min-w-[5.5rem] text-center text-[13px] text-fg-muted">
          Page {page} of {totalPages}
        </span>
        <Button
          variant="ghost"
          size="icon"
          aria-label="Next page"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          icon={<ChevronRight size={14} aria-hidden />}
        />
      </div>
    </div>
  );
}
